import SkeletonBox from "src/components/SkeletonBox/SkeletonBox";

const SSRChipsSkeleton = () => (
  <div className="flex w-full flex-col gap-4">
    {Array.from({ length: 3 }, (_, i) => (
      <div
        key={i}
        className="border-border-subtle bg-background-default flex w-full flex-col items-stretch justify-between gap-4 rounded-md border p-4 md:flex-row md:flex-wrap md:items-center md:p-5"
      >
        <div className="flex items-start gap-3 md:items-center">
          <SkeletonBox className="rounded-xs size-10 shrink-0 md:size-12" />
          <div className="flex flex-col gap-0.5">
            <SkeletonBox className="h-6 w-24" />
            <SkeletonBox className="h-4 w-56 max-w-full" />
          </div>
        </div>
        <div className="flex w-full shrink-0 items-center gap-3 md:w-auto">
          <SkeletonBox className="rounded-pill hidden h-5 w-20 md:block" />
          <SkeletonBox className="h-12 w-full rounded-md md:h-8 md:w-30 md:rounded-xs" />
        </div>
      </div>
    ))}
  </div>
);

export default SSRChipsSkeleton;
